module.exports = __webpack_public_path__ + "media/bootstrap-icons/hurricane-9d41fd5b.svg";